import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChartLineLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M4 4C4.51283 4 4.93551 4.38604 4.99327 4.88338L5 5V18H20C20.5523 18 21 18.4477 21 19C21 19.5128 20.614 19.9355 20.1166 19.9933L20 20H4C3.48717 20 3.06449 19.614 3.00673 19.1166L3 19V5C3 4.44772 3.44772 4 4 4ZM20.1935 6.81813C21.0933 6.81813 21.5439 7.90606 20.9076 8.54231L15.3386 14.1114C14.909 14.541 14.2125 14.541 13.7829 14.1114L11.0252 11.3537L7.48969 14.8892C7.09916 15.2797 6.466 15.2797 6.07547 14.8892C5.68495 14.4987 5.68495 13.8655 6.07547 13.475L10.2474 9.30305C10.677 8.87347 11.3735 8.87348 11.803 9.30305L14.5608 12.0608L17.8034 8.81813H17.3892C16.8369 8.81813 16.3892 8.37041 16.3892 7.81813C16.3892 7.26584 16.8369 6.81813 17.3892 6.81813H20.1935Z" })
});
export default SvgChartLineLine;
